import { render, staticRenderFns } from "./IconCalendarClock.vue?vue&type=template&id=3505a40c"
import script from "./IconCalendarClock.vue?vue&type=script&lang=js"
export * from "./IconCalendarClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports